module.exports = __webpack_public_path__ + "static/media/web_inner.1031cc3a.webp";